import request from '@/utils/request'

export function updatePopUpCfg(data) {
  return request({
    url: 'api/v1/pop-up/updatePopUpCfg',
    method: 'post',
    data: data
  })
}

export function getPopUpCfg(data) {
  return request({
    url: 'api/v1/pop-up/getPopUpCfg',
    method: 'get',
    params: data
  })
}

export function deletePopUpCfg(data) {
  return request({
    url: 'api/v1/pop-up/delete',
    method: 'delete',
    data: data
  })
}

